
import { Options, Vue } from "vue-class-component";
import hamburgerIcon from "../images/hamburger-icon.svg";
import SvgIcon from "@/components/ui/BaseIcons/SvgIcon.vue";

@Options({
  name: "MenuBtn",
  components: {
    SvgIcon,
  },
  props: {
    isActive: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
})
export default class MenuBtn extends Vue {
  hamburgerIcon = hamburgerIcon;
}
